import { connect } from 'react-redux';
import { IPermissionFAQModalEvents } from 'app/view/react_components/dialogs/permissionsFAQModal/components/PermissionsFAQModal/types';
import { PermissionsFAQModal } from '../../components/PermissionsFAQModal/PermissionsFAQModal';
import { onClose } from './events/onClose';
import { onClick } from './events/onClick';

const mapDispatchToProps = (
    dispatch: any,
): IPermissionFAQModalEvents => {
    return {
        onClose: () => dispatch(onClose()),
        onClick : (source) => dispatch(onClick(source))
    }
};

export const PermissionsFAQModalHOC = connect(
    null,
    mapDispatchToProps
)(PermissionsFAQModal);

PermissionsFAQModalHOC.displayName = 'PermissionsFAQModalHOC';
